export default "__VITE_ASSET__DNDrytZI__"